/** @file RFC 1951 constants: length/distance bases and extra bits, code length order, fixed code lengths. */

/**
 * Length symbols 257-285 and distance symbols 0-29: base values and extra bits (§3.2.5); the order in which a dynamic
 * block lists its code length code lengths (§3.2.7); fixed code lengths (§3.2.6) as [first symbol, last, length] runs
 * over literal/length 0-287 then distance 288-319.
 */
export const DEFLATE_TABLES = {
  lenBase: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258],
  lenExtra: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0],
  distBase: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577],
  distExtra: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13],
  codeLengthOrder: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15],
  fixedRuns: [[0, 143, 8], [144, 255, 9], [256, 279, 7], [280, 287, 8], [288, 319, 5]],
} as const;
